import {Component, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {InputComponent} from "../../../../shared-module/components/input/input.component";
import {ButtonComponent} from "../../../../shared-module/components/button/button.component";
import AbstractMyAccountDialogComponent
  from "../abstract-my-account-dialog.component";

import {ErrorDisplayComponent} from "../../../../shared-module/error-display/error-display.component";
import {matchesOtherControlValidator} from "../../../../shared-module/validators/matches-other-control.validator";
import {distinctUntilChanged} from "rxjs";

@Component({
    selector: 'app-edit-email-dialog',
    imports: [
    InputComponent,
    ButtonComponent,
    ReactiveFormsModule,
    ErrorDisplayComponent
],
    templateUrl: './edit-email-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './edit-email-dialog.component.scss'
})
export class EditEmailDialogComponent extends AbstractMyAccountDialogComponent {

  public successMessage: string = "Je e-mailadres is succesvol gewijzigd.";

  public override form: FormGroup = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),
    confirm_email: new FormControl("", [Validators.required, Validators.email, matchesOtherControlValidator("email")]),
    current_password: new FormControl("", [Validators.required]),
  });

  constructor() {
    super();
    this.form.controls['email'].valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.form.controls['email'].updateValueAndValidity();
      this.form.controls['confirm_email'].updateValueAndValidity();
    });

    this.form.controls['confirm_email'].valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.form.controls['email'].updateValueAndValidity();
      this.form.controls['confirm_email'].updateValueAndValidity();
    });
  }
}
